/**
 * Schéma affichage + sync — canaux notification (application / email / SMS).
 */

export const DEFAULT_CHANNEL_PREFERENCES = {
  notifications: true,
  notifications_email: true,
  notifications_sms: false
};

const toBoolean = (value, fallback = false) => {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return ['true', '1', 'yes', 'oui', 'on'].includes(normalized);
  }
  return Boolean(value);
};

export const normalizeChannelPreferences = (raw = {}) => ({
  notifications: toBoolean(
    raw.notifications ?? raw.notifications_app ?? raw.notificationsApp,
    DEFAULT_CHANNEL_PREFERENCES.notifications
  ),
  notifications_email: toBoolean(
    raw.notifications_email ?? raw.emailNotifications ?? raw.notificationsEmail,
    DEFAULT_CHANNEL_PREFERENCES.notifications_email
  ),
  notifications_sms: toBoolean(
    raw.notifications_sms ?? raw.smsNotifications ?? raw.notificationsSms,
    DEFAULT_CHANNEL_PREFERENCES.notifications_sms
  )
});

/** État formulaire Apparence (thème + langue + 3 canaux). */
export const buildAppearanceFormState = (raw = {}) => {
  const channels = normalizeChannelPreferences(raw);
  return {
    theme: raw.theme || 'light',
    language: raw.language || 'fr',
    ...channels
  };
};

export const pickAppearancePayload = (appearance = {}) => ({
  theme: appearance.theme,
  language: appearance.language,
  notifications: appearance.notifications,
  notifications_email: appearance.notifications_email,
  notifications_sms: appearance.notifications_sms
});
